import type { Page } from '../../types';

const civilSanctions: Page[] = [
  {
    pageType: 'question',
    title: 'Civil Sanctions',
    name: 'civil-sanctions-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any civil sanctions to declare?',
        name: 'sanctions_civil_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Civil Sanctions',
    name: 'civil-sanctions',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'sanctions_civil_instances' },
        { title: 'Total Value', field: 'sanctions_civil' },
      ],
    },
    disabled: [
      {
        field: 'sanctions_civil_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'Total number of instances',
        name: 'sanctions_civil_instances',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'Estimated total value',
        name: 'sanctions_civil',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'sanctions_civil_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default civilSanctions;




